import { render, staticRenderFns } from "./Pep.vue?vue&type=template&id=25b7d5bc"
import script from "./Pep.vue?vue&type=script&lang=js"
export * from "./Pep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports